import { render as preactRender } from 'preact';
import { html } from 'htm/preact';

import instantsearch from 'instantsearch.js';
import { connectSortBy } from 'instantsearch.js/es/connectors';
import defaultStatsTemplates from 'instantsearch.js/es/widgets/stats/defaultTemplates.js';
import { history as historyRouter } from 'instantsearch.js/es/lib/routers';
import { singleIndex } from 'instantsearch.js/es/lib/stateMappings';

import {
  configure,
  index,
  infiniteHits,
  searchBox,
  stats
} from 'instantsearch.js/es/widgets';

import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter/src/TypesenseInstantsearchAdapter.js';

import { headerMenu } from './header.js';
import { eventFormatDate } from '../$content/events.js';
import { date as formatDate } from '../utils/dates.js';

import Icon from '../utils/icon.js';
import searchIconUrl from 'url:../assets/svgs/search.svg';
import closeIconUrl from 'url:../assets/svgs/close.svg';

import styles from './search.module.scss';

const icons = {
  'search': Icon('search', `class="${styles.searchBoxButtonIcon}" role="presentation"`, {
    'search': searchIconUrl
  }),
  'close': Icon('close', `class="${styles.searchBoxButtonIcon}" role="presentation"`, {
    'close': closeIconUrl
  })
};

export const init = (Alpine) => {
  Alpine.data('search', searchComponent);
};

export const searchComponent = () => {
  const searchPage = new URL(document.querySelector('link[rel=canonical]').href).pathname ===
    '/search/';
  
  const headerMenuComponent = headerMenu();

  return {
    ...headerMenuComponent,
    searchPage,
    open: searchPage,
    query: '',
    mounted: false,
    backdropUrl: undefined,
    searchUrl: new URL('/search/', location.href),
    toggle(shouldOpen) {
      if (this.searchPage) {
        let searchBox = this.$refs.wrapper.querySelector('#searchbox input');

        if (this.hasOpen) {
          document.querySelector(`.header`).addEventListener('focusin', () => {
            this.$nextTick(() => {
              this.$focus.focus(searchBox);
            });
          }, { once: true });
          
          this.$dispatch('closeMenu');
        } else {
          this.$focus.focus(searchBox);
        }
      } else {
        shouldOpen = typeof shouldOpen !== 'undefined' ? shouldOpen : !this.open;

        if (shouldOpen) {
          navigation.navigate(this.searchUrl, {
            navigationType: 'push'
          })
        } else {
          navigation.traverseTo(this.backdrop);
        }
      }
    },
    listen() {
      if (!this.searchPage) {
        return headerMenuComponent.listen.apply(this);
      }
    },
    wrapper() {
      return {
        'x-ref': 'wrapper',
        ':class'() {
          return {
            [styles.wrapper]: true,
            [styles.wrapperOverlay]: !this.searchPage
          };
        },
        'x-init'() {
          this.mounted = true;
        }

      };
    },
    pageTitle() {
      return {
        style: 'font: inherit',
        'x-init': '$el.parentElement.replaceChildren($el)',
        'x-data'() {
          return {
            title: {
              'x-text': `query ? 'Search Results: ' : \`${this.$el.parentElement.textContent}\``,
              style: 'font: inherit'
            }
          };
        }
      }
    },
    init() {
      headerMenuComponent.init.bind(this.$data)();

      let host = 'j4mgphdy2ezqrc3bp-1.a2.typesense.net',
        apiKey = 'VcMgMgWmEyVei6WeNBNibye4DzvE4tG9',
        port = 443,
        protocol = 'https';
        
      if (!searchPage) {
        navigation.addEventListener('navigate', async (event) => {
          let destination = new URL(event.destination.url);

          if (event.destination.key === this.backdrop && this.open) {
            this.backdrop = undefined;
            this.open = false;

            return;
          }

          if (destination.pathname === this.searchUrl.pathname) {
            if (!this.open) {
              await event.intercept({
                handler: () => {
                  if (new URL(navigation.transition.from.url).pathname !== destination.pathname) {
                    this.backdropUrl = navigation.transition.from.url;
                    this.backdrop = navigation.transition.from.key;
                  }

                  this.open = true;
                }
              });
            }
          } else if (event.navigationType === 'push' && navigation.currentEntry.url !== this.searchUrl.href && event.destination.url === this.searchUrl.href) {
            await event.intercept({
              handler: async () => {
                if (new URL(navigation.transition.from.url).pathname !== destination.pathname) {
                  this.backdropUrl = navigation.transition.from.url;
                  this.backdrop = navigation.transition.from.key;
                }
                event
                this.open = true;
              }
            })
            
          } else if (event.navigationType !== 'push') {  
            if (!this.open && destination.pathname === this.searchUrl.pathname) {
              this.open = true;
              return;
              // event.intercept({
              //   handler: async () => {
              //   }
              // })
            } else if (this.open && destination.pathname === this.backdropUrl.pathname) {
              this.open = false;
              return;
              // event.intercept({
              //   handler: async () => {
              //     this.open = false;
              //   }
              // })
            }
          }
        });
      }

      let defaultEval = `id:*`,
        decayOrigin = Math.round(new Date().getTime() / 1000),
        eventSort = `_eval(${defaultEval}):desc, _text_match:desc, start(origin: ${decayOrigin}, func: diff, offset: 0, scale: 1000, decay: 0.5):asc`;

      let eventsConfig = {
        query_by: 'title,subtitle,summary',
        query_by_weights: '10,9,3',
        prefix: 'true,false,false',
        group_limit: 5,
        sort_by: eventSort
      };

      const initialConfig = {
        server: { nodes: [{ host, port, protocol }], apiKey },
        union: true,
        flattenGroupedHits: false,
        additionalSearchParameters: {
          validate_field_names: false,
          text_match_type: 'max_weight',
          prioritize_token_position: true,
          prioritize_num_matching_fields: true,
          prioritize_exact_match: true,
          highlight_affix_num_tokens: 30,
          drop_tokens_threshold: 0,
          group_by: 'url',
          group_limit: 1,
          sort_by: `_eval(${defaultEval}):desc, _text_match:desc, sortKey:asc`
        },
        collectionSpecificSearchParameters: {
          'ticketed-events': {
            ...eventsConfig,
            query_by: 'title,subtitle',
            query_by_weights: '14,9',
            prefix: 'true,false'
          },
          exhibitions: {
            ...eventsConfig,
            query_by: 'title,subtitle,summary',
            query_by_weights: '11,11,3',
            prefix: 'true,false,false',
            preset: 'exhibitions'
          },
          products: {
            query_by: 'title,tags,description',
            query_by_weights: '10,9,3'
          },
          cinema: {
            ...eventsConfig,
            preset: 'cinema'
          },
          events: {
            ...eventsConfig,
            preset: 'standard-events'
          },
          artworks: {
            query_by: 'title,creators',
            query_by_weights: '9,5',
            sort_by: `_eval([(image:!http*):-1,(${defaultEval}):0]):desc, _text_match:desc, sortKey:asc`
          },
          website: {
            query_by: 'title,content',
            query_by_weights: '11,5',
            preset: 'website-content'
          },
          stories: {
            query_by: 'title,tags,summary',
            query_by_weights: '10,9,3',
            sort_by: `_eval(${defaultEval}):desc, _text_match:desc, publishedAt(origin: ${decayOrigin}, func: diff, offset: 0, scale: 1000, decay: 0.75):asc`
          },
          'media-releases': {
            query_by: 'title,content',
            query_by_weights: '2,1',
            preset: 'media-releases',
            prioritize_token_position: false,
            prioritize_num_matching_fields: false
          },
          'education-resources': {
            collection: 'qagoma.qld.gov.au',
            query_by: 'title,content',
            query_by_weights: '2,1',
            preset: 'education-resources',
            prioritize_token_position: false,
            prioritize_num_matching_fields: false
          }
        }
      };

      const adapter = new CustomisedTypesenseInstantSearchAdapter(
        JSON.parse(JSON.stringify(initialConfig))
      );

      const multiSearchAdapter = new CustomisedTypesenseInstantSearchAdapter(
        { ...JSON.parse(JSON.stringify(initialConfig)), union: false }
      );

      const adapterExhibitionTickets = new CustomisedTypesenseInstantSearchAdapter(
        JSON.parse(JSON.stringify(initialConfig))
      );

      const adapterMultiSearchExhibtionTickets = new CustomisedTypesenseInstantSearchAdapter(
        { ...JSON.parse(JSON.stringify(initialConfig)), union: false }
      );

      const { searchClient } = adapter;

      searchClient.search = async function (requests) {
        if (requests.every(({ params }) => !params.query)) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              hitsPerPage: 0,
              exhaustiveNbHits: false,
              query: '',
              params: ''
            }))
          });
        }

        let primaryAdapter = adapter, secondaryAdapter = multiSearchAdapter, exhibitionsRequest;

        if (
          exhibitionsRequest = requests.find(
            ({ indexName, params }) =>
              indexName === 'exhibitions' && params.query?.match(/^tickets?$/)
          )
        ) {
          await getTicketedEvents();

          primaryAdapter = adapterExhibitionTickets;
          secondaryAdapter = adapterMultiSearchExhibtionTickets;

          requests.push({
            ...exhibitionsRequest,
            indexName: 'ticketed-events',
            params: {
              ...exhibitionsRequest.params,
              query: '*'
            }
          });
        }

        let [unionRequests, indexRequests] = requests.reduce(([unionRequests, indexRequests], request, index) => {

          if (index === 0 || request.indexName === 'union') {
            return [unionRequests.concat(request), indexRequests];
          } else {
            return [unionRequests, indexRequests.concat(request)];
          }
        }, [[], []]);

        let [unionRequest] = unionRequests;

        let responses = [primaryAdapter.searchTypesenseAndAdapt(indexRequests)];

        if (unionRequest.indexName !== 'union') {
          responses.push(secondaryAdapter.searchTypesenseAndAdapt(indexRequests))
        }
              
        let i = 0;

        return await Promise.all(responses).then(async ([unionResponse, response = unionResponse]) => {
          
          let typesenseResponse = response.typesenseResponse;

          return {
            results: await Promise.all(requests.map(async (request, index) => {
              if (request.indexName === 'union') {
                return unionResponse.results[0];
              } else if (index === 0) {
                let responseIndex = indexRequests.findIndex(
                  ({ indexName }) => indexName === unionRequest.indexName
                );

                return {
                  collection: typesenseResponse.results[responseIndex].request_params
                    .collection_name,
                  ...response.results[responseIndex]
                };
              } else {
                let result = response.results[i];

                if (typesenseResponse.union_request_params) {
                  result = {
                    ...result,
                    hits: [],
                    nbHits:
                      typesenseResponse.union_request_params[i]?.found || 0
                  };
                }

                i++;

                return result;
              }
            }))
          }
        });

        function getTicketedEvents() {
          if (!this.ticketedEvents) {
            let url = new URL(
              `/vX/data/query/production`,
              `https://m2obzhc2.api.sanity.io`
            );

            url.searchParams.set(
              'query',
              `*[_type == "event" && type in ['exhibition','cinema-program'] && (defined(ticketing.type) && ticketing.type != 'none') && dateTime(end) > dateTime(now())] | order(select(type == 'exhibition' => 1, 0) desc, coalesce(priority, 0) desc, start asc, end asc)[]._id`
            );

            this.ticketedEvents = fetch(url)
              .then((response) => response.json())
              .then(({ result }) => {
                let rankedEval = `[${result.reverse().map((id, i) => `(id:=${id}):${i + 2}`).concat(
                  `(title:=Visit):1`,
                  `(${defaultEval}):0`
                ).join(',')}]`;

                [adapterExhibitionTickets, adapterMultiSearchExhibtionTickets].forEach((adapter) => {
                  let collectionConfig = adapter.configuration.collectionSpecificSearchParameters;

                  collectionConfig['ticketed-events'].sort_by = collectionConfig.exhibitions.sort_by = collectionConfig.cinema.sort_by = eventSort.replace(defaultEval, rankedEval);
                  collectionConfig['ticketed-events'].filter_by = `id:=[${result.join(',')}]`;

                  collectionConfig.website.sort_by = adapter.configuration.additionalSearchParameters.sort_by.replace(defaultEval, rankedEval);

                  adapter.updateConfiguration(adapter.configuration);
                });

                
                return result;
              })
              .catch(() => {
                delete this.ticketedEventIds;
              });
          }
          
          return this.ticketedEvents;
        }
      };
    
      let _self = this;

      let router = historyRouter({
        cleanUrlOnDispose: false,
        windowTitle: ((initialTitle) => {
          return function windowTitle({ query }) {
            if (query) {
              return initialTitle.replace('Search', `Search Results: ${query}`);
            } else {
              return initialTitle;
            }
          };
        })(document.title),
        ...(!searchPage ? {
          dispose() {
            if (location.href !== _self.backdropUrl.href) {
              _self.searchUrl = new URL(location.href);
            }
          },
          start() {
            if (location.href !== _self.searchUrl.href) {
              _self.backdropUrl = new URL(location.href);
              _self.backdrop = navigation.currentEntry.key;
            }
          },
          getLocation() {
            return new URL(_self.searchUrl);
          }
        } : {})
      });

      const search = instantsearch({
        searchClient,
        indexName: 'union',
        routing: true,
        routing: {
          router: router,
          stateMapping: (({ stateToRoute, routeToState }) => ({
            stateToRoute: (params) => {
              console.log(params, stateToRoute(params));
              return stateToRoute(params)
            },
            routeToState: (params) => {
              console.log(params, routeToState(params));
              return routeToState(params)
            }
          }))(singleIndex('union'))
        },
        future: {
          preserveSharedStateOnUnmount: true
        }
      });

      search.on('render', () => {
        this.query = search.helper.getQuery().query;
      });

      Alpine.effect(() => {
        if (!this.open && search.started) {
          search.dispose();
        }
      });

      Alpine.effect(() => {
        if (this.mounted && this.open && !search.started) {
          let timerId,
            timeout = 200;

          search.addWidgets([
            unionIndex({
              container: '#collectionSelect',
              items: [
                { label: 'All', value: 'union' },
                { label: 'Exhibitions', value: 'exhibitions' },
                { label: 'Store', value: 'products' },
                { label: 'Cinema', value: 'cinema' },
                { label: 'Events', value: 'events' },
                { label: 'Artworks', value: 'artworks' },
                { label: 'Media Releases', value: 'media-releases' },
                { label: 'Pages', value: 'website' },
                { label: 'Stories', value: 'stories' },
                { label: 'Education Resources', value: 'education-resources' }
              ],
              cssClasses: {
                root: styles.collectionSelect,
                option: styles.collectionSelectOption,
                input: styles.collectionSelectOptionInput,
              }
            }),
            stats({
              container: '#stats',
              cssClasses: {
                root: styles.stats,
              },
              templates: {
                text({ query, nbHits }) {
                  if (nbHits === 0 && query === '') return ``;
                  
                  return defaultStatsTemplates.text(...arguments);
                }
              }
            }),

            infiniteHits({
              showPrevious: true,
              container: '#hits',
              cssClasses: {
                root: styles.hits,
                list: styles.hitsList,
                item: styles.hitItem,
                loadPrevious: styles.showPrevious,
                loadMore: styles.showMore
              },
              transformItems(items, { results }) {
                return items.map((item, index) => ({
                  ...item,
                  collection: item.collection || results.collection,
                  image: item.image?.url ?? item.image
                }));
              },
              templates: {
                empty(results, { html }) {
                  if (!results.query) return null;
                  
                  return html`<p>No results <q>${results.query}</q></p>`;
                },
                item(hit, { html, components: { Highlight, Snippet } }) {
                  let indexUrl,
                    indexLabel = hit.collection?.replace(
                      /(^\w)((?:(?!s$).)+).*?$/,
                      (...matches) => `${matches[1].toUpperCase()}${matches[2]}`
                    ),
                    title = Highlight({
                      hit,
                      attribute: 'title',
                      cssClasses: { root: styles.highlight }
                    }),
                    subtitle = Highlight({
                      hit,
                      attribute: 'subtitle',
                      cssClasses: { root: styles.highlight }
                    }),
                    image =
                      hit.image ||
                      hit.document?.image ||
                      'https://collection.qagoma.qld.gov.au/sites/default/files/styles/large/filesqagoma/assets/image-pending.jpg?itok=SDhxQrcw',
                    link = hit.url,
                    alt = `${hit.title}${hit.subtitle ? `: ${hit.subtitle}` : ``}`;

                  switch (hit.collection) {
                    case 'objects':
                      indexUrl = 'https://collection.qagoma.qld.gov.au';
                      indexLabel = 'Collection';
                      subtitle =
                        hit._highlightResult?.creators?.map &&
                        Highlight({
                          hit: {
                            _highlightResult: {
                              creators: hit._highlightResult.creators?.map(
                                (creator) => creator?.name || creator
                              )
                            }
                          },
                          attribute: 'creators',
                          cssClasses: { root: styles.highlight }
                        });
                      link = new URL(
                        hit.id,
                        'https://collection.qagoma.qld.gov.au/objects/'
                      );
                      alt = `Image of the artwork: ${hit.title}`;

                      break;

                    case 'events':
                      let start = new Date(hit.start * 1000),
                        end = new Date(hit.end * 1000);

                      title = html`${title}${hit.subtitle ? `: ` : ``}${subtitle}`;

                      subtitle = eventFormatDate({ type: hit.type, start, end });

                      if(hit._group_found > 1) {
                        subtitle = [
                          html`<time datetime="${start.toISOString()}">${subtitle}</time>`,
                          html`<span> + ${hit._group_found - 1} more</span>`
                        ];
                      }

                      switch (hit.type) {
                        case 'exhibition':
                          indexUrl = '/whats-on/exhibitions/';
                          indexLabel = 'Exhibition';
                          break;
                        case 'exhibition-touring':
                          indexUrl = '/whats-on/touring/';
                          indexLabel = 'Touring Exhibition';
                          break;
                        case 'cinema-program':
                        case 'cinema-screening':
                          indexUrl = '/cinema';
                          indexLabel = `Cinema ${hit.type === 'cinema-program' ? 'Program' : 'Screening'}`;

                          break;
                      }

                      break;
                    case 'products':
                      let min = hit.price?.min || 0,
                        max = hit.price?.max || min;

                      if (min || max) {
                        subtitle = new Intl.NumberFormat('en-AU', {
                          style: 'currency',
                          currency: 'AUD'
                        }).formatRange(...[min, max].sort()).replaceAll('~', '');
                      }

                      indexUrl = 'https://qagoma.store';
                      indexLabel = 'Store';

                      break;
                    case 'stories':
                      indexUrl = '/stories';
                      indexLabel = 'Stories';
                      subtitle = formatDate(new Date(hit.publishedAt * 1000), { showDay: false, showTime: false });

                      break;
                    case 'qagoma.qld.gov.au':
                      if (hit.tags?.includes('media-release')) {
                        indexUrl = '/media';
                        indexLabel = 'Media Release';
                      } else if (hit.tags?.includes('education-resource')) {
                        indexUrl = '/learn/education-resources/';
                        indexLabel = 'Education Resource';
                      }

                      break;
                    default:
                  }

                  return html` <div
                  class="${[styles.hit, styles[`hit--${hit.collection}`]]
                      .filter(Boolean)
                      .join(' ')}">
                  <a href="${link}" target="_blank">
                    <figure class="${styles.hitImageWrapper}">
                      <picture
                        style="--background-image:url('${image}')">
                        <img
                          ref="${imageRef}"
                          class="${styles.hitImage} ${(
                        image.match(/collection\.qagoma\.qld\.gov\.au\/|cdn\.shopify\.com/)
                      ) ?
                        styles.hitImageContain
                        : ``}"
                          src="${image}"
                          alt="${alt}"
                          loading="lazy" />
                      </picture>
                    </figure>
                  </a>

                  <header class="card__header">
                    <h1 class="heading-md">
                      <a href="${link}" target="_blank">${title}</a>
                    </h1>

                    ${indexUrl ?
                      html`<div class="card__header__pretitle">
                        <span><a href="${indexUrl}" target="_blank">${indexLabel}</a></span>
                      </div>`
                      : ``}

                    ${subtitle ? html`<div class="hit-subtitle">${subtitle}</div>` : ``}
                  </header>

                  <div
                    class="card__summary truncate"
                    x-show="$el.textContent.length > 0">
                    ${Snippet({ attribute: 'summary', hit })}
                    ${Snippet({ attribute: 'content', hit })}
                    ${Snippet({ attribute: 'description', hit })}
                  </div>
                </div>`;
                }
              }
            }),

            configure({ hitsPerPage: 24 }),

            searchBox({
              autofocus: true,
              container: '#searchbox',
              placeholder: 'Enter your query to begin searching',
              cssClasses: {
                root: styles.searchBox,
                form: styles.searchBoxForm,
                input: styles.searchBoxInput,
                submit: styles.searchBoxButton,
                submitIcon: styles.searchBoxButtonIcon,
                reset: styles.searchBoxButton,
                resetIcon: [
                  styles.searchBoxButtonIcon,
                  styles.searchBoxButtonIconClose
                ]
              },
              templates: {
                submit({ cssClasses }, { html }) {
                  return html`${icons.search}`.replace('<svg', `<svg class="${cssClasses.submitIcon}"`);
                },
                reset({ cssClasses }, { html }) {
                  return html`${icons.close}`.replace('<svg', `<svg class="${cssClasses.resetIcon}"`);
                }
              },
              queryHook(query, refine) {
                clearTimeout(timerId);

                timerId = setTimeout(() => {
                  if (query.length > 1) {
                    refine(query);
                  } else {
                    refine('');
                  }
                }, timeout);
              }
            }),
          ]);
          
          search.start();
          search.refresh();

          if (!searchPage) {
            this.$nextTick(() => {
              this.$refs.wrapper.querySelector('#searchbox input').focus();
            });
          }
        }
      });

      function imageRef(image) {
        if (!image) return;

        const handleLoad = () => {
          image.classList.remove(styles.hitImageLoading);
        };

        const handleError = () => {
          image.onerror = null;
          image.classList.remove(styles.hitImageLoading);
          image.classList.add(styles.hitImageError);
          image.alt = 'No image available';
        };

        if (image.src.startsWith('https://collection.qagoma.qld.gov.au/sites/default/files/styles/large/filesqagoma/assets/image-pending.jpg')) {
          image.src = '';
          handleError();
          return;
        }

        image.onerror = handleError;
        image.onload = handleLoad;

        if (!image.complete) {
          image.classList.add(styles.hitImageLoading);
        }
      }
    }
  };
};

export default init;

class CustomisedTypesenseInstantSearchAdapter extends TypesenseInstantSearchAdapter {
  async _adaptAndPerformTypesenseRequest(instantsearchRequests) {
    let typesenseResponse = await super._adaptAndPerformTypesenseRequest(
      instantsearchRequests
    );

    this.typesenseResponse = typesenseResponse;

    return typesenseResponse;
  }

  async searchTypesenseAndAdapt(instantsearchRequests, transform = (response) => response) {
    const adaptedResponse = await super.searchTypesenseAndAdapt.bind(this)(instantsearchRequests);

    return {
      ...adaptedResponse,
      typesenseResponse: this.typesenseResponse
    }    
  }
}

function unionIndex(params) {
  const { container, ...connectorParams } = params;
  const { render, dispose } = createUnionIndexRenderer({
    container,
  });

  const createWidget = connectUnionIndex(render, dispose);

  return {
    ...createWidget(connectorParams),
    $$widgetType: 'custom.unionIndex',
  };

  function connectUnionIndex(renderFn, unmountFn) {
    return function (widgetParams) {

      const connectorState = {},
        connector = connectSortBy(renderFn, unmountFn),
        sortBy = connector(widgetParams);

      return {
        ...sortBy,
        init(initOptions) {
          let { parent } = initOptions;

          parent.addWidgets(
            widgetParams.items.reduce((acc, { value: indexName }) => {
              if (indexName === connectorState.initialIndex) return acc.concat(
                index({ indexName, indexId: `${indexName}_alt` })
              );

              return acc.concat(index({ indexName }));
            }, [])
          );

          sortBy.init.call(this, initOptions);
        },
        getRenderState() {
          let { sortBy: unionIndex, ...renderState } = sortBy.getRenderState.call(this, ...arguments);

          return { ...renderState, unionIndex };
        },
        getWidgetRenderState({ parent }) {
          if (!connectorState.initialIndex && parent) {
            connectorState.initialIndex = parent.getIndexName();
          }

          const renderState = sortBy.getWidgetRenderState.call(this, ...arguments);
          const scopedResults = parent.getScopedResults();

          return {
            ...renderState,
            initialIndex: connectorState.initialIndex,
            hasQuery: Boolean(parent.getHelper().getQuery()?.query),
            options: renderState.options.map(({ value, ...option }) => ({
                ...option,
                value,
                count: scopedResults.find(({ indexId }, i) => i !== 0 && (indexId === value || indexId === `${value}_alt`))?.results?.nbHits || 0
              })).sort(({ count: a, indexName }, { count: b }) => {
                if (indexName === connectorState.initialIndex) return -1;

                return b - a;
              })
          };
        },
        getWidgetUiState() {
          let { sortBy: collection, ...uiState } = sortBy.getWidgetUiState.call(this, ...arguments);

          return { ...uiState, collection };
        },
        getWidgetSearchParameters(searchParameters, { uiState }) {
          return searchParameters.setQueryParameter('index', uiState.collection || connectorState.initialIndex || searchParameters.index);
        },
        $$type: 'custom.unionIndex',
      };
    };
  }

  function createUnionIndexRenderer({ container }) {
    const containerNode = document.querySelector(
      container
    );

    return {
      render(renderOptions, isFirstRender) {
        const {
          options,
          currentRefinement,
          initialIndex,
          refine,
          hasQuery,
          widgetParams
        } = renderOptions;

        if (isFirstRender) {
          containerNode.classList.add(widgetParams.cssClasses.root);
          containerNode.setAttribute('role', 'radiogroup');
          containerNode.setAttribute('ariaLabel', 'Search type:');
        }

        preactRender(
          hasQuery ?
            options
              .map(
                ({ value, ...option }) => html`
                <label key="${option.label}" class=${widgetParams.cssClasses.option} title="${option.label === 'All' ? 'Show all results' : `Show ${option.count} results in ‘${option.label}’`}">
                  <input
                    type="radio"
                    name="ais-unionIndex"
                    class=${widgetParams.cssClasses.input}
                    value="${value}"
                    onChange=${(event) => {
                    if (event.target.checked) {
                      refine(value);
                    }
                  }}
                    checked="${value === currentRefinement}"
                    disabled="${option.count === 0}"
                  />
                  ${option.label} (${option.count})
                </label>`
            )
          : null,
          containerNode
        );
      },
      dispose() {
        preactRender(null, containerNode);
      }
    };
  }
}